import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";

import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { SharedModule } from "../shared/shared.module";
import { IconsModule } from "@va/core-library/icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ValuationPageComponent } from "./valuation-page/valuation-page.component";
import { ValuationPageVspeersComponent } from "./valuation-page-vspeers/valuation-page-vspeers.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { ValuationPageCompanyComponent } from "./valuation-page-company/valuation-page-company.component";
import { ValuationGridComponent } from "./valuation-grid/valuation-grid.component";
import { ValuationRatioFilterComponent } from "./valuation-ratio-filter/valuation-ratio-filter.component";
import { ValuationPageChartsComponent } from "./valuation-page-charts/valuation-page-charts.component";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzPopoverModule } from "ng-zorro-antd/popover";

const valuationRoutes: Routes = [
  {
    path: "",
    component: ValuationPageComponent,
    data: {
      title: "Valuation Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];
@NgModule({
  imports: [RouterModule.forChild(valuationRoutes)],
  exports: [RouterModule],
})
export class ValuationPageRoutingModule {}

@NgModule({
  declarations: [
    ValuationPageComponent,
    ValuationPageVspeersComponent,
    ValuationGridComponent,
    ValuationRatioFilterComponent,
    ValuationPageCompanyComponent,
    ValuationPageChartsComponent,
  ],
  imports: [
    CommonModule,
    NzToolTipModule,
    ValuationPageRoutingModule,
    SharedModule,
    NzSkeletonModule,
    NzTabsModule,
    NzSpinModule,
    NzRadioModule,
    NzCheckboxModule,
    NzMenuModule,
    NzButtonModule,
    NzPopoverModule,
    MatTableModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    PeriodFilterModule,
    ChartPlotterModule,
    MatSnackBarModule,
    CurrencySelectModule,
  ],
  exports: [ValuationGridComponent],
})
export class ValuationPageModule {}
